import { Component, EventEmitter, Input, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { switchMap } from 'rxjs/operators';
import { DocumentKind } from 'src/app/shared/model/DocumentKind';
import { CustomDialogService } from 'src/app/shared/services/custom-dialog.service';
import { DocumentInfo } from '../../models/DocumentInfo';
import { DocumentService } from '../../service/document.service';

@Component({
  selector: 'app-document-info-description',
  templateUrl: './document-info-description.component.html',
  styleUrls: ['./document-info-description.component.scss']
})
export class DocumentInfoDescriptionComponent {

  constructor(
    private customDialogService: CustomDialogService,
    private documentService : DocumentService
  ) { }
  @Input() documentInfo:DocumentInfo;

  otherDocumentKind = DocumentKind.OtherClaimDocument;
  @Output() documentChangeEvent = new EventEmitter<any>();

  @ViewChild("descriptionDialog", { read: ViewContainerRef })
  public dialogContainerRef: ViewContainerRef;
  
  editDescription(){

    this.customDialogService.actionWithTextSelection('claims-center.claimDocumentation.setDocumentDescription',
    (text: string) => {

      this.documentService.getDocument(this.documentInfo.id).pipe(
        switchMap(
          (r) => {
            r.description = text;
            this.documentInfo.description = text;
            return this.documentService.updateDocumentInfo(r)
          })).subscribe(() =>  this.documentChangeEvent.emit("changed"));
    },
    this.documentInfo.description,
     true,
     this.dialogContainerRef
    );

  }

}
